class KeyVisual {
    constructor(elem) {
        this.elem = elem;
    }

    init() {
        if (window.location.hash) {
            KeyVisual.scrollToAnchor(window.location.hash);
        }

        $(this.elem).find('a[href*=\\#]:not([href=\\#])').on('click', (e) => {
            KeyVisual.scrollToAnchor(e.currentTarget.hash);
        });
    }

    static scrollToAnchor(hash) {
        const headerHeight = 0;
        let target = $(hash);

        target = target.length ? target : $(`[name=${hash.slice(1)}]`);
        if (target.length) {
            $('html,body').animate({
                scrollTop: target.offset().top - headerHeight,
            }, 100);
        }
    }
}

export default KeyVisual;
